"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCursorTop = exports.getTreeMoveArgs = exports.moveNode = exports.dndManager = void 0;
var dnd_core_1 = require("dnd-core");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
exports.dndManager = (0, dnd_core_1.createDragDropManager)(react_dnd_html5_backend_1.HTML5Backend);
var removeNode = function (treeData, removedNode, currentLevel) {
    if (currentLevel === void 0) { currentLevel = 0; }
    return treeData
        .filter(function (node) { return node.id !== removedNode.id; })
        .map(function (node) {
        if (node.children) {
            return __assign(__assign({}, node), { children: removeNode(node.children, removedNode, currentLevel + 1) });
        }
        return node;
    });
};
var addNode = function (treeData, addedNode, index, parentChain) {
    var recursiveFindAndAdd = function (nodes, currentChain) {
        if (!currentChain.length) {
            return __spreadArray(__spreadArray(__spreadArray([], nodes.slice(0, index), true), [addedNode], false), nodes.slice(index), true);
        }
        return nodes.map(function (node) {
            if (node.id === currentChain[0].id) {
                return __assign(__assign({}, node), { children: recursiveFindAndAdd(node.children || [], currentChain.slice(1)) });
            }
            return node;
        });
    };
    return recursiveFindAndAdd(treeData, parentChain);
};
var getParentArray = function (parents, parent) {
    if (!parent)
        return parents;
    return getParentArray(__spreadArray([parent], parents, true), parent.parent);
};
var moveNode = function (treeData, _a) {
    var movedNode = _a.movedNode, newIndex = _a.newIndex, newParent = _a.newParent;
    var newData = removeNode(treeData, movedNode);
    var parentChain = newParent ? getParentArray([], newParent).map(function (x) { return x.data; }) : [];
    return addNode(newData, movedNode, newIndex, parentChain);
};
exports.moveNode = moveNode;
var getTreeMoveArgs = function (dragNode, dropNode, above) {
    var _a, _b;
    var nodeIsParent = !above && dropNode.data.children;
    var newParent = nodeIsParent ? dropNode : dropNode.parent;
    var newRawIndex = nodeIsParent ? 0 : above ? dropNode.index : dropNode.index + 1;
    var newIndex = ((_a = dragNode.parent) === null || _a === void 0 ? void 0 : _a.id) === ((_b = dropNode.parent) === null || _b === void 0 ? void 0 : _b.id) && newRawIndex > dragNode.index
        ? newRawIndex - 1
        : newRawIndex;
    return {
        movedNode: dragNode.data,
        newIndex: newIndex,
        previousIndex: dragNode.index,
        previousParent: dragNode.parent,
        newParent: newParent,
    };
};
exports.getTreeMoveArgs = getTreeMoveArgs;
var isCursorTop = function (monitor, hoverBoundingRect) {
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var clientOffset = monitor.getClientOffset();
    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
    return Math.floor(hoverClientY) < Math.floor(hoverMiddleY);
};
exports.isCursorTop = isCursorTop;
